import { render, staticRenderFns } from "./AbkRemoveAccountModal.vue?vue&type=template&id=7c74c992&scoped=true&"
import script from "./AbkRemoveAccountModal.vue?vue&type=script&lang=js&"
export * from "./AbkRemoveAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./AbkRemoveAccountModal.vue?vue&type=style&index=0&id=7c74c992&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74c992",
  null
  
)

export default component.exports